/**
 * 邀请/佣金 API
 */

import type { HttpClient } from '../http/HttpClient'
import type {
  RewardDetail,
  RecommendUser,
  RecommendFailLog,
  RewardItem,
  WithdrawRecord,
  PaginatedResponse,
  PaginationParams,
  InviteInfo,
  WithdrawParams,
  WithdrawResponse
} from '../../types/invite'

export class InviteAPI {
  private http: HttpClient

  constructor(http: HttpClient) {
    this.http = http
  }

  /**
   * 获取佣金详情
   */
  async getRewardDetail(): Promise<RewardDetail> {
    const response = await this.http.get<{ data: RewardDetail }>('/api/commission/rewards')
    return response.data.data
  }

  /**
   * 申请提现
   */
  async applyWithdraw(params?: WithdrawParams): Promise<WithdrawResponse> {
    const response = await this.http.post<WithdrawResponse>(
      '/api/commission/withdrawal',
      params || {}
    )
    return response.data
  }

  /**
   * 获取佣金列表
   */
  async getRewardList(params: PaginationParams): Promise<PaginatedResponse<RewardItem>> {
    const response = await this.http.get<{ data: PaginatedResponse<RewardItem> }>(
      '/api/commission/inviteRewards',
      { params }
    )
    return response.data.data
  }

  /**
   * 获取推荐失败列表
   */
  async getRecommendFailList(
    params: PaginationParams
  ): Promise<PaginatedResponse<RecommendFailLog>> {
    const response = await this.http.get<{ data: PaginatedResponse<RecommendFailLog> }>(
      '/api/userRecommends/failLogs',
      { params }
    )
    return response.data.data
  }

  /**
   * 获取推荐用户列表
   */
  async getRecommendUserList(params: PaginationParams): Promise<PaginatedResponse<RecommendUser>> {
    const response = await this.http.get<{ data: PaginatedResponse<RecommendUser> }>(
      '/api/commission/recommendedUsers',
      { params }
    )
    return response.data.data
  }

  /**
   * 获取提现记录
   */
  async getWithdrawRecordList(
    params: PaginationParams
  ): Promise<PaginatedResponse<WithdrawRecord>> {
    const response = await this.http.get<{ data: PaginatedResponse<WithdrawRecord> }>(
      '/api/commission/withdrawal/log',
      { params }
    )
    return response.data.data
  }

  /**
   * 获取邀请人信息
   */
  async getInviteInfo(): Promise<InviteInfo> {
    const response = await this.http.get<InviteInfo>('/api/commission/userReferrer')
    return response.data
  }
}
